import { Stage, Layer, Image as KonvaImage } from 'react-konva';
import useImage from '../../hooks/useImage';
import useMediaQuery from '../../hooks/useMediaQuery';

const CanvasComponentContent = ({ bg, overlay, size }) => {
    const backgroundImage = useImage(bg);
    const overlayImage = useImage(overlay);
    const isMatch = useMediaQuery('(max-width: 1023.98px)');

    if (!backgroundImage || !overlayImage) return null;

    return (
        <div className="relative col-span-4 sm:block hidden" >
            <Stage width={isMatch ? 650 : 800} height={531}>
                <Layer>
                    <KonvaImage
                        image={backgroundImage}
                        width={759}
                        height={531}
                    />
                    <KonvaImage
                        image={overlayImage}
                        x={250}
                        y={100}
                        draggable
                        width={size.width * 2.9}
                        height={size.height * 2.9}
                        shadowColor="rgba(0, 0, 0, 0.5)"
                        shadowBlur={3}
                        shadowOffsetX={1}
                        shadowOffsetY={1}
                        // skewX={0}
                        // skewY={-.09}
                        // scaleX={.8}
                        // scaleY={1.1}
                    />
                </Layer>
            </Stage>
        </div>
    );
};

export default CanvasComponentContent;
